import useToastContext from 'hooks/useToastContext'
import { compact, isEmpty } from 'lodash'
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { apiPost } from 'utils/apiFetch'
import apiPath from 'utils/apiPath'
import pdfIcon from 'assets/icons/pdf.png'
import galleryIcon from 'assets/icons/gallery.png'
import AuthContext from 'context/AuthContext'

function UploadDocument({ propertyId, editProperty, tabs, setTab }) {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const notification = useToastContext()
  const [deleteDocuments, setDeleteDocument] = useState([])
  const { config } = useContext(AuthContext);
  const [documentsData, setDocumentsData] = useState([
    {
      documentTitle: '',
      image: ''
    }
  ])
  const handleFileUploadSingle = e => {
    const getType = e.target.files[0].type.split('/')
    const fileSize = (e.target.files[0]?.size / (1024 * 1024)).toFixed(2)
    if (
      getType[1] !== undefined &&
      (getType[1] === 'jpeg' || getType[1] === 'pdf')
    ) {
      if (fileSize > 2) {
        notification.error('Please select document below 2 MB')
      } else {
        return true
      }
    } else {
      notification.error('Only jpeg and pdf formats are allowed')
    }
  }
  const deleteDocument = index => {
    setDocumentsData(
      documentsData.map((percentage, tempIndex) => {
        if (tempIndex === index) {
          return {
            ...percentage,
            image: ''
          }
        }
        return percentage
      })
    )
  }
  const deleteDocumentWithTitle = (index, img) => {
    if (typeof img !== 'object') {
      if (!isEmpty(img)) {
        const dbUrl = img?.split(config?.country === "Saudi" ? "o/" : "net/")
        setDeleteDocument(prev => [...prev, dbUrl[1]])
      }
    }
    const temp = documentsData.filter((document, ind) => ind !== index)
    setDocumentsData(temp)
  }

  const uploadDocuments = async data => {
    const updatedTemp = documentsData?.filter(
      res =>
        res.documentTitle !== '' &&
        (res.image !== '' || typeof res.image === 'object')
    )

    // if (updatedTemp.length === 0) {
    //   notification.error('Please select one document with title.')
    //   return
    // }

    const formData = new FormData()
    formData.append('_id', propertyId)
    if (deleteDocuments?.length > 0) {
      formData.append(
        'deleteDocuments',
        JSON.stringify(compact(deleteDocuments))
      )
    }
    for (let i = 0; i < updatedTemp?.length; i++) {
      formData.append('documents', updatedTemp[i].image)
    }

    formData.append(
      'documentTitle',
      JSON.stringify(
        updatedTemp?.map(res => {
          return res.documentTitle
        })
      )
    )

    const { data: response } = await apiPost(apiPath.uploadPhotos, formData)
    if (response.success) {
      notification.success(response.message)
    }
    if (editProperty?.forAuction) {
      navigate('/auction')
    } else {
      navigate('/properties')
    }
  }
  useEffect(() => {
    if (!isEmpty(editProperty)) {
      if (editProperty?.documents?.length > 0) {
        const defaultFloorData = editProperty?.documents?.map(item => {
          return {
            documentTitle: item?.title,
            image: item?.image,
            disabled: true
          }
        })
        setDocumentsData(defaultFloorData)
      }
    }
  }, [])

  const handleDocuments = (index, item) => {
    const check = handleFileUploadSingle(item)
    if (check) {
      setDocumentsData(
        documentsData?.map((res, ind) => {
          if (index === ind) {
            return {
              ...res,
              image: item.target.files[0]
            }
          } else {
            return res
          }
        })
      )
    }
  }

  const addMoreFloor = () => {
    setDocumentsData([
      ...documentsData,
      {
        documentTitle: '',
        image: ''
      }
    ])
  }
  return (
    <>
      <div className='gap-4 xl:gap-12 '>
        {/* <div className='py-3 mb-1 flex-0  w-1/3'>
          <label className='block'>
            <span className='block text-sm font-medium text-gray-400'>
              {t('PROPERTY_OWNERSHIP')}
            </span>
            <div className='relative flex border rounded-md overflow-hidden mt-1'>
              <span className='absolute p-3 left-0 right-0 top-auto text-sm'>
                {t('UPLOAD_PROPERTY_OWNERSHIP')}
              </span>
              <input
                type='file'
                accept='image/png, image/jpg, image/jpeg, .docx, .pdf'
                name='propertyOwnership'
                ref={propertyOwnershipRef}
                onChange={handleFileChange}
                // className='hidden'
                placeholder='10.95'
                className='opacity-0 cursor-pointer px-3 py-3 bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
              />
              <button className='flex items-center justify-center absolute right-0 top-3 xl:top-4 text-white text-sm rounded-r w-[32px] xl:w-[64px]'>
                <img src='../images/upload.svg' alt='' />
              </button>
            </div>
            <div className='text-center mt-4'>
              <ErrorMessage message={propertyOwnershipError} />
            </div>
          </label>

          {propertyOwnership && (
            <div className='flex-[4]'>
              <div className='w-[485px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden'>
                <figure className='w-full h-full'>
                  <OImage
                    //   src={typeof propertyOwnership === 'object' ? URL?.createObjectURL(propertyOwnership) : propertyOwnership}
                    src={
                      typeof propertyOwnership === 'object'
                        ? URL?.createObjectURL(propertyOwnership)
                        : typeof propertyOwnership === 'string'
                          ? propertyOwnership
                          : '/images/user.png'
                    }
                    fallbackUrl='/images/user.png'
                    className='w-full h-full object-cover'
                    alt=''
                  />
                </figure>
                <button
                  className='absolute top-[10px] right-[10px]'
                  onClick={(e) => setPropertyOwnership('')}
                >
                  <img src='../images/photo_close.png' alt='' />
                </button>
              </div>
            </div>)}

        </div>

        <div className='py-3 mb-1 flex-0  w-1/3'>
          <label className='block'>
            <span className='block text-sm font-medium text-gray-400'>
              {t('POWER_OF_ATTORNEY')}
            </span>
            <div className='relative flex border rounded-md overflow-hidden mt-1'>
              <span className='absolute p-3 left-0 right-0 top-auto text-sm'>
                {t('UPLOAD_POWER_OF_ATTORNEY')}
              </span>
              <input
                type='file'
                accept='image/png, image/jpg, image/jpeg, .docx, .pdf'
                name='powerOfAttorney'
                ref={powerOfAttorneyRef}
                onChange={handleFileChange}
                placeholder='10.95'
                className='opacity-0 px-3 cursor-pointer py-3 bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
              />
              <button className='flex items-center justify-center absolute right-0 top-3 xl:top-4 text-white text-sm rounded-r w-[32px] xl:w-[64px]'>
                <img src='../images/upload.svg' alt='' />
              </button>
            </div>
          </label>

          {powerOfAttorney && (
            <div className='flex-[4] ml-5 mt-5'>
              <div className='w-[485px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md  overflow-hidden'>
                <span className='relative'>
                  <figure className='w-full h-full'>
                    <OImage
                      src={
                        typeof powerOfAttorney === 'object'
                          ? URL?.createObjectURL(powerOfAttorney)
                          : typeof powerOfAttorney === 'string'
                            ? powerOfAttorney
                            : '/images/user.png'
                      }
                      fallbackUrl='/images/user.png'
                      className='w-full h-full object-cover'
                      alt=''
                    />
                  </figure>
                  <button
                    className='absolute top-[10px] right-[10px]'
                    onClick={() => setPowerOfAttorney('')}
                  >
                    <img src='../images/photo_close.png' alt='' />
                  </button>
                </span>
              </div>
            </div>)}
        </div>

        <div className='py-3 mb-1 flex-0  w-1/3'>
          <label className='block'>
            <span className='block text-sm font-medium text-gray-400'>
              {t('OWNER_ID')}
            </span>
            <div className='relative flex border rounded-md overflow-hidden mt-1'>
              <span className='absolute p-3 left-0 right-0 top-auto text-sm'>
                {t('UPLOAD_OWNER_ID')}
              </span>
              <input
                type='file'
                accept='image/png, image/jpg, image/jpeg, .docx, .pdf'
                name='ownerId'
                ref={ownerIdRef}
                onChange={handleFileChange}
                placeholder='10.95'
                className='opacity-0 px-3 py-3 cursor-pointer bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1'
              />
              <button className='flex items-center justify-center absolute right-0 top-3 xl:top-4 text-white text-sm rounded-r w-[32px] xl:w-[64px]'>
                <img src='../images/upload.svg' alt='' />
              </button>
            </div>
          </label>
          {ownerId && (
            <div className='flex-[4] mt-4'>
              <div className='w-[485px] h-[164px] xl:w-[204px] xl:h-[204px] rounded-md relative overflow-hidden ml-7'>
                <figure className='w-full h-full'>
                  <OImage
                    src={
                      typeof ownerId === 'object'
                        ? URL?.createObjectURL(ownerId)
                        : typeof ownerId === 'string'
                          ? ownerId
                          : '/images/user.png'
                    }
                    fallbackUrl='/images/user.png'
                    className='w-full h-full object-cover'
                    alt=''
                  />
                </figure>
                <button
                  className='absolute top-[10px] right-[10px]'
                  onClick={() => setOwnerId('')}
                >
                  <img src='../images/photo_close.png' alt='' />
                </button>
              </div>
            </div>)}
        </div> */}
        <div>
          <h4 className='text-lg font-semibold pt-3'>
            {t('UPLOAD_DOCUMENTS')}
          </h4>
          {/* <span className='block text-red-500'>{t('DOCUMENT_SUGGESTION')}</span> */}
          <span className='block text-red-500'>{t('DOCUMENT_FORMAT')}</span>
        </div>
        <div>
          {documentsData?.length > 0 &&
            documentsData?.map((item, index) => {
              const type = item?.image?.type?.split('/')[1]
              return (
                <div className='flex  gap-4 xl:gap-12 ' key={index}>
                  <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/3'>
                    <label className='block'>
                      <span className='block text-sm font-medium text-gray-400'>
                        {t('DOCUMENT_TITLE')}
                      </span>
                      <input
                        type='text'
                        name='documentTitle'
                        className='mt-1 rounded-[4px] border p-3 hover:outline-none focus:outline-none hover:border-yellow-500 w-full'
                        placeholder={t('ENTER_DOCUMENT_TITLE')}
                        value={item?.documentTitle}
                        disabled={item?.disabled}
                        onChange={e => {
                          setDocumentsData(
                            documentsData?.map((res, ind) => {
                              if (ind === index) {
                                return {
                                  ...res,
                                  documentTitle: e.target.value
                                }
                              } else {
                                return res
                              }
                            })
                          )
                        }}
                      />
                    </label>
                  </div>

                  <div className='py-3 mb-1 flex-0 w-1/2 xl:w-1/3 flex justify-between items-center'>
                    <label className='block w-[calc(100%-55px)]'>
                      <span className='flex justify-between items-center text-sm font-medium text-gray-400'>
                        {t('DOCUMENT')}
                        {typeof item.image === 'string' &&
                          item?.image?.includes('.pdf') && (
                            <img src={pdfIcon} alt='' />
                          )}
                        {typeof item.image === 'string' &&
                          item?.image?.includes('.jpg') && (
                            <img src={galleryIcon} alt='' />
                          )}
                      </span>
                      <div className='flex items-center'>
                        <div className='relative flex border rounded-md overflow-hidden mt-1 w-[100%]'>
                          <span className='absolute p-3 left-0 right-0 top-auto'>
                            {item?.image !== '' &&
                              typeof item?.image !== 'object'
                              ? item?.image?.slice(-16)
                              : typeof item?.image === 'object'
                                ? 'Uploaded Document'
                                : 'Upload Document'}
                          </span>
                          {item.image !== '' &&
                            typeof item.image !== 'object' ? (
                            <div className='opacity-0 px-3 py-3 bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full sm:text-sm focus:ring-1 w-[324px] h-12' />
                          ) : (
                            <input
                              type='file'
                              // placeholder={
                              //   item?.image?.name
                              //     ? 'Uploaded Document'
                              //     : 'Upload Document'
                              // }
                              onChange={e => handleDocuments(index, e)}
                              disabled={item?.disabled}
                              className='opacity-0 px-3 py-3 bg-transparent relative z-10 border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-[324px] sm:text-sm focus:ring-1'
                            />
                          )}
                          <button
                            type='button'
                            className='flex items-center justify-center absolute right-0 top-4 text-white text-sm rounded-r w-[64px]'
                          >
                            <img src='../images/upload.svg' alt='' />
                          </button>
                        </div>
                      </div>
                    </label>
                    {item?.image === '' && (
                      <button
                        type='button'
                        className='ml-3 block text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-5  bg-blue-200 w-[40px] h-[40px]'
                        onClick={() =>
                          deleteDocumentWithTitle(index, item.image)
                        }
                      >
                        <span className=' text-[#222]  text-lg ' title='Close'>
                          ×
                        </span>
                      </button>
                    )}
                    {item?.image !== '' &&
                      (type === 'pdf' ||
                        type === 'jpg' ||
                        type === 'png' ||
                        type === 'jpeg') ? (
                      <div className='flex items-center mt-5 ml-2'>
                        <div className='abc relative w-[100px]'>
                          <button
                            type='button'
                            className='z-20 bg-[#000] ml-3 block text-white rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none absolute top-[-6px] right-[-4px] w-[16px] h-[16px]'
                            onClick={() => deleteDocument(index)}
                          >
                            <span className='' title='Close'>
                              ×
                            </span>
                          </button>
                          <div className='overflow-hidden rounded bg-gray-300 whitespace-nowrap text-ellipsis relative'>
                            <span className='mx-4 text-black'>
                              {item?.image?.name}
                            </span>
                          </div>
                        </div>
                        <button
                          type='button'
                          className='ml-3 block text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]'
                          onClick={() =>
                            deleteDocumentWithTitle(index, item.image)
                          }
                        >
                          <span
                            className=' text-[#222]  text-lg '
                            title='Close'
                          >
                            ×
                          </span>
                        </button>
                      </div>
                    ) : item?.image !== '' ? (
                      <div className='flex items-center mt-5'>
                        <a
                          href={item?.image}
                          target='_blank'
                          className='mt-2 ml-2 py-1 btn btn-primary bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded  hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 undefined '
                          style={{ fontSize: '14px' }}
                          rel='noreferrer'
                        >
                          View
                        </a>
                        {(editProperty?.isApprovedStatus === 'pending' ||
                          editProperty?.isApprovedStatus === 'draft' ||
                          editProperty?.addedBy === 'admin') && (
                            <button
                              type='button'
                              className='ml-3 block text-black rounded-full text-xxl leading-none font-extralight outline-none focus:outline-none mt-3  bg-blue-200 w-[40px] h-[40px]'
                              onClick={() =>
                                deleteDocumentWithTitle(index, item.image)
                              }
                            >
                              <span
                                className=' text-[#222]  text-lg '
                                title='Close'
                              >
                                ×
                              </span>
                            </button>
                          )}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              )
            })}
          {(editProperty?.isApprovedStatus === 'pending' ||
            editProperty?.isApprovedStatus === 'draft' ||
            editProperty?.addedBy === 'admin') && (
              <button
                className='text-blue-400'
                type='button'
                onClick={addMoreFloor}
              >
                {t('ADD_MORE')}
              </button>
            )}
        </div>
      </div>

      <div className='border-t mt-10 py-10'>
        <button
          className=' bg-white hover:bg-[#8FC150] hover:border-black hover:text-white cursor-pointer   text-lime-500 border-2 border-lime-500  font-normal active:bg-slate-100 text-md px-8 py-2 rounded hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150
                undefined '
          onClick={() => setTab(tabs.TAB_PHOTOS)}
        >
          {t('GO_BACK')}
        </button>

        <button
          className='bg-lime-500 hover:bg-[#8FC150] cursor-pointer   text-white  font-normal active:bg-slate-100 text-md px-8 py-2.5 rounded  hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150
                undefined '
          onClick={uploadDocuments}
        >
          {t('UPLOAD_LISTING')}
        </button>
      </div>
    </>
  )
}

export default UploadDocument
